import {ISubtitles} from "./LocalizedSubtitles";
import {useEffect, useState} from "react";
import {ProjectDetails} from "../../redux/types/firebase";
import {EditSubtitles} from "./EditSubtitles";

interface IEditEnglishSubtitles {
    blockName: string
    onChange: (update: ISubtitles) => void
    project: ProjectDetails
    subtitles: ISubtitles
}
export function EditEnglishSubtitles({blockName, onChange, project, subtitles}: IEditEnglishSubtitles) {
    const [working, setWorking] = useState(subtitles);
    const handleAddCue = () => {
        working.cues.push({start: 0, stop: 0, text: ""});
        onChange(working);
    };
    const handleMoveCue = (from: number, to: number) => {
        const replace = working.cues[to];

        working.cues[to] = working.cues[from];
        working.cues[from] = replace;
        onChange(working);
    };
    const handleUpdateCue = () => {
        onChange(working);
    };
    const handleDeleteCue = (index: number) => {
        working.cues.splice(index, 1);
        onChange(working);
    }

    useEffect(() => {
        setWorking(JSON.parse(JSON.stringify(subtitles)));
    }, [subtitles]);
    return (
        <EditSubtitles blockName={blockName} cues={working.cues} onAddCue={handleAddCue}
                       onDeleteCue={handleDeleteCue} onMoveCue={handleMoveCue} onUpdateCue={handleUpdateCue}
                       project={project}/>
    );
}
